import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { directMessagesService } from '@/services/direct-messages.service';
import type { GetDirectMessagesParams } from '@/types';

export const useDirectMessages = (churchId: string | undefined, params: GetDirectMessagesParams = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.DIRECT_MESSAGES_REPORTS, churchId, params],
    queryFn: () => {
      if (!churchId) {
        throw new Error('Church ID is required');
      }
      return directMessagesService.getDirectMessages(churchId, params);
    },
    enabled: !!churchId,
  });
};
